
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#3D2562","rx":"8.258"}}),_c('path',{attrs:{"fill":"#FFF","d":"M41.356 25.827l1.508-1.507a.666.666 0 000-.933l-.948-.947a.666.666 0 00-.947 0L39.487 24a12.018 12.018 0 00-4.805-2.36V20c0-.736-.597-1.333-1.335-1.333h-2.67c-.736 0-1.334.597-1.334 1.333v1.64A12.003 12.003 0 0020 33.333c.073 6.464 5.2 11.738 11.666 12a12.015 12.015 0 0011.082-6.661 11.989 11.989 0 00-1.392-12.845zm-9.343 16.84c-5.16 0-9.344-4.179-9.344-9.334 0-5.154 4.184-9.333 9.344-9.333 5.16 0 9.343 4.179 9.343 9.333 0 5.155-4.183 9.334-9.343 9.334zm.774-16a.679.679 0 00-.774.666v6l4.217 4.214a.684.684 0 001.015-.067 6.663 6.663 0 00-4.458-10.813z"}})])])
          )
        }
      }
    